export default "__VITE_ASSET__0f9b35a1__"